export function getGradeNumber(gradeText) {
  const match = /^U(\d+)$/i.exec((gradeText || '').trim())
  return match ? Number(match[1]) : null
}

export function allowsSmallSided(gradeText) {
  const num = getGradeNumber(gradeText)
  return num !== null && num <= 12
}

// Generates a position layout for a given number of players per side.
// 9-12 a side: 3 outfield lines (backs / midfield / forwards)
// 13-15 a side: 5 outfield lines (full backs / half backs / midfield / half forwards / full forwards)
// Leftover players (when line counts don't divide evenly) go to defense first.
export function getFormation(playersPerSide) {
  const size = Math.max(9, Math.min(15, Number(playersPerSide) || 15))
  const outfield = size - 1
  const numLines = size <= 12 ? 3 : 5
  const lineNames = numLines === 3
    ? ['Back', 'Midfield', 'Forward']
    : ['Full Back', 'Half Back', 'Midfield', 'Half Forward', 'Full Forward']
  const lineYs = numLines === 3
    ? [75, 50, 20]
    : [80, 65, 50, 35, 15]

  const base = Math.floor(outfield / numLines)
  let remainder = outfield - base * numLines
  const lineCounts = lineNames.map(() => base)
  // Distribute remainder to defense first, then forwards, alternating outward from the back
  let i = 0
  while (remainder > 0) {
    lineCounts[i % numLines]++
    remainder--
    i++
  }

  const positions = [{ num: 1, x: 50, y: 92 }]
  const positionNames = { 1: 'Goalkeeper' }
  let num = 2
  const maxLineSpan = 70 // matches the width of a standard 15-a-side back line
  const gapPerPlayer = 22
  lineCounts.forEach((count, lineIdx) => {
    const y = lineYs[lineIdx]
    const span = count > 1 ? Math.min(maxLineSpan, (count - 1) * gapPerPlayer) : 0
    for (let j = 0; j < count; j++) {
      const x = count === 1 ? 50 : 50 - span / 2 + j * (span / (count - 1))
      positions.push({ num, x, y })
      positionNames[num] = lineNames[lineIdx] + (count > 1 ? ' ' + (j + 1) : '')
      num++
    }
  })

  return { positions, positionNames }
}